import React from 'react';
import { CulinaryGrid } from '../components/CulinaryGrid';
interface MenuProps {
  onAddToCart?: (item: {
    id: string;
    name: string;
    price: number;
    image: string;
  }) => void;
}
export function Menu({
  onAddToCart
}: MenuProps) {
  return <main className="pt-24 min-h-screen" data-id="element-515">
      <CulinaryGrid onAddToCart={onAddToCart} data-id="element-516" />
    </main>;
}